import ImageGallery from "react-image-gallery";
import React, { useRef, useState } from "react";
import {
  BackwardOutlined,
  CaretLeftOutlined,
  CaretRightOutlined,
  ForwardOutlined,
} from "@ant-design/icons";

const BannersCategory = (props: any) => {
  const { banners } = props;
  const [slideIndex, setSlideIndex] = useState<number>(0);
  const [images, setImages] = useState<any>([]);
  const ref = useRef<ImageGallery>(null);

  React.useEffect(() => {
    setSlideIndex(0);
    setImages(
      banners.map((item: any) => ({
        original: item.path,
        thumbnail: item.path_thumb,
        category: item.category,
      }))
    );
  }, [banners]);

  const handleOnMouseOver = () => {
    if (!ref.current) {
      return;
    }

    ref.current.pause();
  };
  const handleOnMouseLeaver = () => {
    if (!ref.current) {
      return;
    }

    ref.current.play();
  };

  return (
    images && (
      <div className="kd-product-detail-banner-container">
        {slideIndex > 0 ? (
          <a
            onClick={() => ref.current?.slideToIndex(slideIndex - 1)}
            className="btn-prev-slide-img-product">
            {slideIndex !== 0 && slideIndex !== images.length - 1 ? (
              <CaretLeftOutlined />
            ) : (
              <BackwardOutlined />
            )}
          </a>
        ) : null}
        <ImageGallery
          ref={ref}
          autoPlay
          slideInterval={4000}
          items={images?.filter((x: any) => x.category !== "MODEL_3D")}
          showPlayButton={false}
          showFullscreenButton={false}
          renderItem={(item: any) => (
            <div className="image-gallery-img">
              <img src={item.original} />
            </div>
          )}
          showThumbnails={false}
          onSlide={(i) => setSlideIndex(i)}
          onMouseOver={handleOnMouseOver}
          onMouseLeave={handleOnMouseLeaver}
        />
        {slideIndex < images.length - 1 ? (
          <a
            onClick={() => ref.current?.slideToIndex(slideIndex + 1)}
            className="btn-next-slide-img-product">
            {slideIndex !== 0 && slideIndex !== images.length - 1 ? (
              <CaretRightOutlined />
            ) : (
              <ForwardOutlined />
            )}
          </a>
        ) : null}
      </div>
    )
  );
};

export default BannersCategory;
